import { Card } from 'react-bootstrap';

// xs–sm card renderer for one list row. The first column flagged `cardHeader` (or the first
// column) becomes the card title; the rest render as a definition list; actions stack full-width.
export default function FinanceRowCard({ row, columns, actions }) {
  const headerCol = columns.find((c) => c.cardHeader) || columns[0];
  const bodyCols = columns.filter((c) => c !== headerCol);

  return (
    <Card className="mb-2">
      <Card.Body className="py-2 px-3">
        <div className="fw-semibold mb-1">
          {headerCol.header}: {headerCol.cell(row)}
        </div>
        <dl className="row mb-0 small">
          {bodyCols.map((c) => (
            <div key={c.key} className="col-12 d-flex justify-content-between gap-2 py-1 border-top">
              <dt className="text-muted fw-normal">{c.header}</dt>
              <dd className="mb-0 text-end">{c.cell(row)}</dd>
            </div>
          ))}
        </dl>
        {actions && <div className="d-grid gap-1 mt-2">{actions}</div>}
      </Card.Body>
    </Card>
  );
}
